export interface HisSection {
  id: string;
  title: string;
  description: string;
  path: string;
}

export const HIS_HUB_PATH = '/admin/his';

export const HIS_MENU_TITLE = 'HIS Report';

export const HIS_SECTIONS: HisSection[] = [
  {
    id: 'reports',
    title: 'گزارش',
    description: 'عملکرد مالی کاربران پذیرش بر اساس بازه زمانی و نوع پرداخت',
    path: '/admin/his/reports',
  },
  {
    id: 'online-conversion',
    title: 'به ثمر رسیدن نوبت آنلاین',
    description: 'چند نوبت تاییدشده آنلاین واقعاً در HIS پذیرش شده‌اند (کد ملی / موبایل)',
    path: '/admin/his/online-conversion',
  },
  {
    id: 'voids',
    title: 'لغو و حذف',
    description: 'خدمت لغوشده روی پذیرش، پذیرش پاک‌شده، و انجام‌کار پاک‌شده که هنوز در لاگ HIS مانده',
    path: '/admin/his/voids',
  },
];
